import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api';
import SalesBoard from '../components/SalesBoard';
import './RosePage.css';

const BOARDS = {
  st_barbara: {
    kicker: "St Barbara's Kitchen",
    documentTitle: 'St Barbara',
    slug: 'st-barbara',
    accent: 'barbara',
    emptyMessage: 'No items on the St Barbara menu.',
  },
  st_noufer: {
    kicker: "St Noufer's Kitchen",
    documentTitle: 'St Noufer',
    slug: 'st-noufer',
    accent: 'noufer',
    emptyMessage: 'No items on the St Noufer menu.',
  },
};

export default function KitchenPage({ kitchen }) {
  const board = BOARDS[kitchen] || null;
  const slug = board ? board.slug : '';
  const load = useCallback(() => api.getKitchenSales(slug), [slug]);

  if (!board) {
    return (
      <main className="rose-page">
        <header className="rose-head">
          <p className="rose-kicker">Kitchens</p>
          <h1 className="kitchen-pick-title">Choose a kitchen</h1>
        </header>
        <section className="rose-section">
          <ul>
            <li><Link to="/barb">St Barbara's Kitchen</Link></li>
            <li><Link to="/nouf">St Noufer's Kitchen</Link></li>
          </ul>
        </section>
      </main>
    );
  }

  return (
    <SalesBoard
      kicker={board.kicker}
      documentTitle={board.documentTitle}
      emptyMessage={board.emptyMessage}
      accent={board.accent}
      variant="tv"
      load={load}
    />
  );
}
